// const baseApiAddress = 'https://api.hotelmeister.io/rest/ui/backend/';
import { isEmpty, isNil } from 'lodash';

export const baseApiAddresses = {
  development: isEmpty(process.env.BASE_API_DEV) || isNil(process.env.BASE_API_DEV) || process.env.BASE_API_DEV === 'undefined' ? 'http://localhost:8080/rest/ui/backend/' : process.env.BASE_API_DEV,
  demo: 'https://api.simply-hotel.at/rest/ui/backend/',
  nightly: 'http://api.alpvue.com/rest/ui/backend/',
  // production: `https://${process.env.X_API_DOMAIN || 'api.hotelmeister.io'}/rest/ui/backend/`,
  production: 'https://api.hotelmeister.io/rest/ui/backend/',
};
export const baseAddresses = {
  development: ($subdomain, $path, $ssl = false) => `http://localhost:8080${$path}`,
  demo: ($subdomain, $path, $ssl = false) => ($ssl === true ? `https://api.simply-hotel.at${$path}` : `http://${$subdomain}.simply-hotel.at${$path}`),
  nightly: ($subdomain, $path, $ssl = false) => ($ssl === true ? `https://api.alpvue.com${$path}` : `http://${$subdomain}.alpvue.com${$path}`),
  // production: ($subdomain, $path, $ssl = false) => `https://${$subdomain}.${process.env.X_BASE_DOMAIN || 'hotelmeister.io'}${$path}`,
  production: ($subdomain, $path, $ssl = false) => `https://${$subdomain}.hotelmeister.io${$path}`,
};
export const baseOldUiAddresses = {
  development: ($subdomain, $path, $ssl = false) => `http://localhost:8080${$path}`,
  demo: ($subdomain, $path, $ssl = false) => `https://api.simply-hotel.at${$path}`,
  production: ($subdomain, $path, $ssl = false) => `https://api.hotelmeister.io${$path}`,
};

export function getOldUIPath($subdomain, $hotelId, $path, $token, $locale = null, $ssl = false) {
  return `${baseOldUiAddresses[process.env.HOTELMEISTER_ENV]($subdomain, $path, $ssl)}${$path.indexOf('?') >= 0 ? '&' : '?'}token=${$token}&hotelId=${$hotelId}&locale=${$locale || window.i18n.locale}`;
}

export function openOldUI($subdomain, $hotelId, $path, $token, $locale = null, $ssl = false) {
  window.open(getOldUIPath($subdomain, $hotelId, $path, $token, $locale, $ssl));
}



// WEBPACK FOOTER //
// ./src/lib/util/urls.js